module.exports = __webpack_public_path__ + "img/css3-outline.9447c1e3.svg";